import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

// Zurück von den Rechtsseiten (/terms, /imprint, /privacy, /legal) zur Seite, von der man gekommen ist.
@Injectable({ providedIn: 'root' })
export class LegalNavigationService {
  constructor(private location: Location, private router: Router) {}

  back() {
    // 1. Innerhalb der App geöffnet (z. B. über die Fusszeile): eine Seite zurück
    const navigationId = (window.history.state && window.history.state.navigationId) || 0;
    if (navigationId > 1) {
      this.location.back();
      return;
    }
    // 2. In einem neuen Tab geöffnet (Links der Checkboxen): Tab schliessen, der alte Tab ist wieder sichtbar
    window.close();
    // 3. Lässt sich der Tab nicht schliessen: zur Ursprungsseite derselben Anwendung, sonst zur Anmeldung
    setTimeout(() => {
      const referrer = document.referrer;
      try {
        const ref = new URL(referrer);
        if (referrer && ref.origin === window.location.origin && ref.pathname !== window.location.pathname) {
          window.location.href = referrer;
          return;
        }
      } catch (e) {
        // kein gültiger Referrer
      }
      this.router.navigate(['/login']);
    }, 200);
  }
}
